module.exports = __webpack_public_path__ + "media/images/logos/external/glassdoor_logo_green-703c9d6fd9ab36cba73270145023e225.svg";